<template>
	<page-content-layout class="box-list" title="Udestående">
		<button-group-view slot="tools" :actions="[
			{
				label: 'Flyt',
				value: 'move'
			},
			{
				label: 'Reg',
				value: 'reg'
			},
			{
				label: 'Bem',
				value: 'remark'
			}
		]" v-model="filters.sort" />
		<button-group-view slot="tools" :actions="[
			{
				label: 'Alle',
				value: 'all'
			},
			{
				label: 'Til lager',
				value: 'to'
			},
			{
				label: 'Fra lager',
				value: 'from'
			}
		]" v-model="filters.storage" />
		<button-group-view slot="tools" :actions="[
			{
				label: 'Privat',
				value: 'private'
			},
			{
				label: 'Erhverv',
				value: 'business'
			}
		]" v-model="filters.type" />
		<button-group-view slot="tools" :actions="[
			{
				label: 'Begrænset',
				value: false
			},
			{
				label: 'Ubegrænset',
				value: true
			}
		]" v-model="filters.unlimited" />
		<button-view slot="tools" label="Download" @click="download" style="display: inline-block;" />
		<table-view ref="table" :columns="columns" :items="items" @itemClick="itemClick" />
		<new-table-view @itemClick="itemClick" :columns="_columns" :items="_items" @context="itemContext" />
		<div class="status">Status: {{ _status }}</div>
	</page-content-layout>
</template>

<script>
	//import Button from '../components/Button'

	import Window from '../windows/TrackerWindow'

	import ContactModel from '../model/Contact'
	import ContactWindow from '../windows/ContactWindow'

	import NewTableView from '../views/NewTableView'
	//import ContextPopupView from '../views/ContextPopupView'

	//import PackHistory from '../windows/PackHistory'

	import { bus } from '../../bus'

    export default {
		props: [],
		components: {
			NewTableView
		},
		computed: {
			_columns() {
				var r = [
					{
						label: 'Navn',
						name: 'name',
						weight: 3
					},
					{
						label: 'Bemærkning',
						name: 'pack_remarks',
						weight: 5
					},
					{
						label: 'Seneste bem',
						name: 'pack_remarks_change',
						filter: 'date',
						weight: 2
					},
					{
						label: 'Seneste reg',
						name: 'change',
						filter: 'date',
						weight: 2
					},
					{
						label: 'Seneste flyt',
						name: 'move_date',
						filter: 'date',
						weight: 2
					},
					{
						label: 'Dage',
						name: 'days',
						align: 'right',
						weight: 1
					},
					{
						label: 'Til lager',
						name: 'storage_to',
						weight: 1
					},
					{
						label: 'Fra lager',
						name: 'storage_from',
						weight: 1
					},
					{
						label: 'Påmindelser',
						name: 'reminders',
						align: 'right',
						weight: 1
					},
					{
						label: 'Status',
						name: 'pack_qty',
						align: 'right',
						weight: 1
					}
				];

				/*for (var i = 0; i < this.status.cols.length; ++i) {
					r.push({
						weight: 2,
						align: 'right',
						label: this.status.cols[i].label,
						data: (function () {
							var id = self.status.cols[i].id;

							return function (item) {
								//return item.hasOwnProperty(id) ? '<span>' + item[id].home + '</span> - <span>' + item[id].stored  + '</span> - <span>' + 0 + '</span>' : '-';
								var prod = item.status.find(function (p) { return p.id == id; });
								return prod ? prod.qty : '-';
							};
						})()
					});
				}*/

				return r;
			},
			_status() {
				if (this._items === null) {
					return 'Indlæser...';
				}

				var r = 0;

				for (var i = 0; i < this._items.length; ++i) {
					var item = this._items[i];
					r += item.pack_qty;
				}

				return r;
			},
			_items() {
				var r = [];
				var i;
				var item;

				if (this.status === null || this.status.items === null) {
					return null;
				}

				// Filter
				if (this.status.items) {
					for (i = 0; i < this.status.items.length; ++i) {
						item = this.status.items[i];

						if (
							// Private / Business
							((this.filters.type == 'private' && item.roles.hasOwnProperty('private') && item.roles.private.enabled) || (this.filters.type == 'business' && item.roles.hasOwnProperty('business') && item.roles.business.enabled)) &&
							// Unlimited / Limited
							((this.filters.unlimited && item.unlimited_raw) || (!this.filters.unlimited && !item.unlimited_raw)) &&
							// Storage
							((this.filters.storage == 'all') || (this.filters.storage == 'to' && item.storage_to_raw) || (this.filters.storage == 'from' && item.storage_from_raw))
						) {
							r.push(item);
						}
					}
				}

				// Sort
				if (this.filters.sort == 'move') {
					r.sort((a, b) => {
						a = a.move_date;
						b = b.move_date;

						// equal items sort equally
						if (a === b) {
							return 0;
						}
						// nulls sort after anything else
						else if (a === null) {
							return 1;
						}
						else if (b === null) {
							return -1;
						}
						// otherwise, if we're ascending, lowest sorts first
						a = new Date(a);
						b = new Date(b);
						return a < b ? -1 : 1;
					});
				}

				if (this.filters.sort == 'reg') {
					r.sort((a, b) => {
						a = a.change;
						b = b.change;

						// equal items sort equally
						if (a === b) {
							return 0;
						}
						// nulls sort after anything else
						else if (a === null) {
							return 1;
						}
						else if (b === null) {
							return -1;
						}
						// otherwise, if we're ascending, lowest sorts first
						a = new Date(a);
						b = new Date(b);
						return a < b ? -1 : 1;
					});
				}

				if (this.filters.sort == 'remark') {
					r.sort((a, b) => {
						a = a.pack_remarks_change;
						b = b.pack_remarks_change;

						// equal items sort equally
						if (a === b) {
							return 0;
						}
						// nulls sort after anything else
						else if (a === null) {
							return 1;
						}
						else if (b === null) {
							return -1;
						}
						// otherwise, if we're ascending, lowest sorts first
						a = new Date(a);
						b = new Date(b);
						return a < b ? -1 : 1;
					});
				}

				return r;
			}
		},
		methods: {
			createButtonClick: function () {
				var contacts = this;

				this.$store.state.windowStack.push(Window, {
					onChange: function (ent) {
						
						

						contacts.update();
					}
				});
			},
			itemContext(item, event) {
				event.stopPropagation();

				//var self = this;

				/*this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					actions: [
						{
							label: 'Opret med fakturering hertil',
							action: async function () {
								//await ContactModel.delete(item.id);
								//self.update();
								alert('ikke klar');
							}
						},
						{
							label: 'Opret kopi',
							action: async function () {
								//await ContactModel.delete(item.id);
								//self.update();
								alert('ikke klar');
							}
						},
						null,
						{
							label: 'Slet',
							action: async function () {
								if (await ContactModel.delete(self.axios, item.id)) {
									self.update();
								}
							}
						}
					]
				});*/
			},
			async itemClick(item) {
				

				var self = this;
				var ent = await ContactModel.read(self.axios, item.id);

				self.$store.state.windowStack.push(ContactWindow, {
					value: ent,
					initActive: 'pack', 
					submit: async function (entity) {
						if (await ContactModel.save(self.axios, entity)) {
							self.$store.state.windowStack.pop();
							self.update();
						}
					}
				});
			},
			action: function (name, id) {
				if (name == 'delete' && confirm('Sure?')) {
					

					var contacts = this;

					this.axios
						.delete('/boxes/' + id + '/')
						.then(function () {
							contacts.update();
						}, function () {
							alert('Could not delete the item');
						});
				}
			},
			update() {
				var self = this;

				self.status = null;

				this.axios
					.get('/pack/status/')
					.then(function (r) {
						self.status = r.data;
					});
			},
			download() {
				if (!Array.isArray(this._items)) return;

				let csv = 'Type;Navn;Telefon;E-mail;Bemærkning;Seneste bemærkning;Seneste registrering;Seneste flytning;Dage;Til lager;Fra lager;Påmindelser;Status\n';

				this._items.forEach((item) => {
					let row = [
						item.roles.hasOwnProperty('business') && item.roles.business.enabled ? 'Erhverv' : 'Privat',
						item.name ? item.name.toString().replace(/(\r\n|\n|\r)/gm, "") : '',
						item.phone ? item.phone.toString().replace(/(\r\n|\n|\r)/gm, "") : '',
						item.email ? item.email.toString().replace(/(\r\n|\n|\r)/gm, "") : '',
						item.pack_remarks ? item.pack_remarks.toString().replace(/(\r\n|\n|\r)/gm, "") : '',
						item.pack_remarks_change ? item.pack_remarks_change.slice(0, 19).replace('T', '_') : '',
						item.change ? item.change.slice(0, 19).replace('T', '_') : '',
						item.move_date ? item.move_date.slice(0, 19).replace('T', '_') : '',
						item.days,
						item.storage_to,
						item.storage_from,
						item.reminders,
						item.pack_qty
					];

					csv += row.join(';');
					csv += "\n";
				});
			
				const datetime	= new Date().toISOString().slice(0, 19).replace('T', '_').replace(/:/g, '-');
				const anchor	= document.createElement('a');
				anchor.href		= 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
				anchor.target	= '_blank';
				anchor.download	= `udestaaende_emballage_${datetime}.csv`;
				anchor.click();
			},
		},
		data: function () {
			return {
				items: null,
				columns: [],
				status: {
					cols: [],
					items: null
				},				
				actions: [
					{name: 'delete', label: 'Delete'}
				],

				filters: {
					type: 'private',
					unlimited: false,
					sort: 'move',
					storage: 'all'
				}
			};
		},
		mounted: function () {
			this.axios.put('/activity/packaging/');
			
			this.update();

			var self = this;

			bus.$on('update', function () {
				self.update();
			});

			bus.$on('clear', function () {
				self.items = null;
			});


			/*this.axios
				.all([
					this.axios.get('/contacts/'),
					this.axios.get('/contacts/columns/')
				]).then(function (results) {
					
				});*/
		},
		beforeRouteLeave(to, from, next) {
			bus.$off('update');
			bus.$off('clear');

			next();
		}
    }
</script>

<style lang="scss">
	.box-list {
		& > * > .status {
			position: absolute;
			right: 40px;
			bottom: 40px;
			background-color: #F7223F;
			color: white;
			font-weight: bold;
			font-size: 14px;
			padding: 10px 20px 10px 20px;
			border-radius: 5px;
			opacity: 0.8;

			-webkit-box-shadow: 1px 1px 2px 1px rgba(0,0,0,0.35); 
			box-shadow: 1px 1px 2px 1px rgba(0,0,0,0.35);
		}
	}
</style>